import { useContext, useState } from "react";

import { swaDate } from "@swa-ui/date";
import { FetchOptionsContext } from "@swa-ui/fetch";
import { logger } from "@swa-ui/log";

export const useRequest = (Api, method, AuthContext = {}, getCondition = true) => {
  const { appendLogoutHandlers, authPending, isLoggedIn } = useContext(AuthContext) || {};
  const loggedIn = isLoggedIn?.();
  const fetchOptions = useContext(FetchOptionsContext);
  const [loading, setLoading] = useState(false);

  return async function request(parameters) {
    const resetData = () => null;

    return getCondition && !authPending && !loading
      ? makeRequest()
      : Promise.resolve(createResponse());

    async function makeRequest(options = {}) {
      const start = swaDate();

      setLoading(true);

      return method
        .call(Api, parameters, { ...options, ...fetchOptions })
        .then((response) => {
          const body = getBody(response);
          const data = loggedIn ? body?.data : null;

          setLoading(false);
          appendLogoutHandlers && appendLogoutHandlers(refresh, body.path);

          return createResponse(data, isDataPending(response), null);
        })
        .catch(async (error) => {
          const callDuration = swaDate().diff(start);
          const payload = { callDuration, error };

          setLoading(false);
          logger.error(`FETCH ERROR`, payload);

          return createResponse(null, false, payload);
        });
    }

    function refresh(options) {
      return makeRequest({ "no-cache": true, ...options });
    }

    function get(options) {
      return makeRequest(options);
    }

    function isDataPending(response, error = false) {
      return loading || (!response && !error);
    }

    function createResponse(data, pending, error) {
      setLoading(false);

      return {
        data: data || null,
        dataPending: pending || false,
        error: error || null,
        get,
        loading,
        refresh,
        resetData,
      };
    }
  };
};

function getBody(response) {
  return typeof response === "string"
    ? JSON.parse(response)
    : Array.isArray(response)
    ? response[0]
    : response;
}
